"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.createClientViewClient = createClientViewClient;
exports.getManifest = getManifest;
exports.getPreviewManifest = getPreviewManifest;
exports.getListings = getListings;
exports.getListingAggregates = getListingAggregates;
exports.getListingMapPins = getListingMapPins;
exports.getListingDetail = getListingDetail;
exports.submitLead = submitLead;
exports.trackEvent = trackEvent;
exports.getDataset = getDataset;
exports.getPwaManifest = getPwaManifest;
exports.getCommunities = getCommunities;
exports.resolveRuntimeUrl = resolveRuntimeUrl;
exports.getSponsorships = getSponsorships;
exports.trackSponsorshipImpression = trackSponsorshipImpression;
exports.trackSponsorshipClick = trackSponsorshipClick;
const authApi = __importStar(require("./auth.js"));
const http_js_1 = require("./http.js");
function createClientViewClient(defaultOptions = {}) {
    const withDefaults = (options) => ({
        ...defaultOptions,
        ...options,
        headers: { ...defaultOptions.headers, ...options?.headers },
    });
    return {
        getManifest(slug, options) {
            return getManifest(slug, withDefaults(options));
        },
        getPreviewManifest(slug, previewToken, options) {
            return getPreviewManifest(slug, previewToken, withDefaults(options));
        },
        getListings(slug, params, options) {
            return getListings(slug, params, withDefaults(options));
        },
        getListingAggregates(slug, params, options) {
            return getListingAggregates(slug, params, withDefaults(options));
        },
        getListingMapPins(slug, params, options) {
            return getListingMapPins(slug, params, withDefaults(options));
        },
        getListingDetail(slug, listingIdOrSlug, params, options) {
            return getListingDetail(slug, listingIdOrSlug, params, withDefaults(options));
        },
        submitLead(slug, payload, options) {
            return submitLead(slug, payload, withDefaults(options));
        },
        trackEvent(slug, eventPayload, options) {
            return trackEvent(slug, eventPayload, withDefaults(options));
        },
        getDataset(slug, dataSourceId, params, options) {
            return getDataset(slug, dataSourceId, params, withDefaults(options));
        },
        getPwaManifest(slug, options) {
            return getPwaManifest(slug, withDefaults(options));
        },
        signup(slug, payload, options) {
            return authApi.signup(slug, payload, withDefaults(options));
        },
        login(slug, payload, options) {
            return authApi.login(slug, payload, withDefaults(options));
        },
        logout(slug, options) {
            return authApi.logout(slug, withDefaults(options));
        },
        getCurrentUser(slug, options) {
            return authApi.getCurrentUser(slug, withDefaults(options));
        },
        updateProfile(slug, payload, options) {
            return authApi.updateProfile(slug, payload, withDefaults(options));
        },
        getSavedListings(slug, options) {
            return authApi.getSavedListings(slug, withDefaults(options));
        },
        saveListing(slug, payload, options) {
            return authApi.saveListing(slug, payload, withDefaults(options));
        },
        removeSavedListing(slug, savedListingId, options) {
            return authApi.removeSavedListing(slug, savedListingId, withDefaults(options));
        },
        removeSessionSavedListing(slug, savedListingId, visitorId, options) {
            return authApi.removeSessionSavedListing(slug, savedListingId, visitorId, withDefaults(options));
        },
        getSavedSearches(slug, options) {
            return authApi.getSavedSearches(slug, withDefaults(options));
        },
        saveSearch(slug, payload, options) {
            return authApi.saveSearch(slug, payload, withDefaults(options));
        },
        listSavedSearchRevisions(slug, savedSearchId, options) {
            return authApi.listSavedSearchRevisions(slug, savedSearchId, withDefaults(options));
        },
        updateSavedSearch(slug, savedSearchId, payload, options) {
            return authApi.updateSavedSearch(slug, savedSearchId, payload, withDefaults(options));
        },
        deleteSavedSearch(slug, savedSearchId, options) {
            return authApi.deleteSavedSearch(slug, savedSearchId, withDefaults(options));
        },
        listSessionSavedListings(slug, visitorId, options) {
            return authApi.listSessionSavedListings(slug, visitorId, withDefaults(options));
        },
        listSessionSavedSearches(slug, visitorId, options) {
            return authApi.listSessionSavedSearches(slug, visitorId, withDefaults(options));
        },
        mergeGuestActivity(slug, payload, options) {
            return authApi.mergeGuestActivity(slug, payload, withDefaults(options));
        },
        getBuyerProfile(slug, options) {
            return authApi.getBuyerProfile(slug, withDefaults(options));
        },
        patchBuyerProfile(slug, payload, options) {
            return authApi.patchBuyerProfile(slug, payload, withDefaults(options));
        },
        getSponsorships(slug, params, options) {
            return getSponsorships(slug, params, withDefaults(options));
        },
        trackSponsorshipImpression(slug, placementId, payload, options) {
            return trackSponsorshipImpression(slug, placementId, payload, withDefaults(options));
        },
        trackSponsorshipClick(slug, placementId, payload, options) {
            return trackSponsorshipClick(slug, placementId, payload, withDefaults(options));
        },
        resolveRuntimeUrl,
        getBaseUrl(options) {
            return (0, http_js_1.resolveConfig)(withDefaults(options)).baseUrl;
        },
    };
}
async function getManifest(slug, options = {}) {
    const body = await (0, http_js_1.publicRequest)(`/api/v1/views/${encodeURIComponent(slug)}/manifest`, options);
    return body;
}
async function getPreviewManifest(slug, previewToken, options = {}) {
    const query = (0, http_js_1.buildQuery)({ token: previewToken });
    return (0, http_js_1.publicRequest)(`/api/v1/views/${encodeURIComponent(slug)}/preview-manifest${query}`, options);
}
async function getListings(slug, params = {}, options = {}) {
    const query = (0, http_js_1.buildQuery)(params);
    return (0, http_js_1.publicRequest)(`/api/v1/views/${encodeURIComponent(slug)}/listings${query}`, options);
}
async function getListingAggregates(slug, params = {}, options = {}) {
    const query = (0, http_js_1.buildQuery)(params);
    return (0, http_js_1.publicRequest)(`/api/v1/views/${encodeURIComponent(slug)}/listings/aggregates${query}`, options);
}
async function getListingMapPins(slug, params = {}, options = {}) {
    const query = (0, http_js_1.buildQuery)(params);
    return (0, http_js_1.publicRequest)(`/api/v1/views/${encodeURIComponent(slug)}/listings/map${query}`, options);
}
async function getListingDetail(slug, listingIdOrSlug, params = {}, options = {}) {
    const query = (0, http_js_1.buildQuery)(params);
    return (0, http_js_1.publicRequest)(`/api/v1/views/${encodeURIComponent(slug)}/listings/${encodeURIComponent(listingIdOrSlug)}${query}`, options);
}
async function submitLead(slug, payload, options = {}) {
    return (0, http_js_1.publicRequest)(`/api/v1/views/${encodeURIComponent(slug)}/leads`, {
        ...options,
        method: "POST",
        body: payload,
    });
}
async function trackEvent(slug, eventPayload, options = {}) {
    try {
        return await (0, http_js_1.publicRequest)(`/api/v1/views/${encodeURIComponent(slug)}/events`, {
            ...options,
            method: "POST",
            body: eventPayload,
        });
    }
    catch {
        return null;
    }
}
async function getDataset(slug, dataSourceId, params = {}, options = {}) {
    const query = (0, http_js_1.buildQuery)(params);
    return (0, http_js_1.publicRequest)(`/api/v1/views/${encodeURIComponent(slug)}/datasets/${encodeURIComponent(dataSourceId)}${query}`, options);
}
async function getPwaManifest(slug, options = {}) {
    return (0, http_js_1.publicRequest)(`/api/v1/views/${encodeURIComponent(slug)}/pwa-manifest.json`, options);
}
/**
 * Communities endpoint is not part of the public API yet.
 * Callers should feature-detect or catch 404 until the API ships.
 */
async function getCommunities(slug, params = {}, options = {}) {
    const query = (0, http_js_1.buildQuery)(params);
    return (0, http_js_1.publicRequest)(`/api/v1/views/${encodeURIComponent(slug)}/communities${query}`, options);
}
function resolveRuntimeUrl(slug, route = "/", options = {}) {
    const basePath = options.runtimeBasePath ?? "/v";
    const normalizedRoute = route.startsWith("/") ? route : `/${route}`;
    return `${basePath}/${encodeURIComponent(slug)}${normalizedRoute === "/" ? "" : normalizedRoute}`;
}
async function getSponsorships(slug, params = {}, options = {}) {
    const query = (0, http_js_1.buildQuery)(params);
    return (0, http_js_1.publicRequest)(`/api/v1/views/${encodeURIComponent(slug)}/sponsorships${query}`, options);
}
async function trackSponsorshipImpression(slug, placementId, payload = {}, options = {}) {
    try {
        return await (0, http_js_1.publicRequest)(`/api/v1/views/${encodeURIComponent(slug)}/sponsorships/${encodeURIComponent(placementId)}/impression`, { ...options, method: "POST", body: payload });
    }
    catch {
        return null;
    }
}
async function trackSponsorshipClick(slug, placementId, payload = {}, options = {}) {
    try {
        return await (0, http_js_1.publicRequest)(`/api/v1/views/${encodeURIComponent(slug)}/sponsorships/${encodeURIComponent(placementId)}/click`, { ...options, method: "POST", body: payload });
    }
    catch {
        return null;
    }
}
